import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(
    lazy(() => import('views/dashboard/Default'))
);

// utilities routing
const UtilsTypography = Loadable(
    lazy(() => import('views/utilities/Typography'))
);
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(
    lazy(() => import('views/utilities/MaterialIcons'))
);
const UtilsTablerIcons = Loadable(
    lazy(() => import('views/utilities/TablerIcons'))
);

//  page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));
const NewsPage = Loadable(lazy(() => import('views/pages/NewsPage')));
const AllCryptosPage = Loadable(
    lazy(() => import('views/pages/AllCryptosPage'))
);
const CoinPage = Loadable(lazy(() => import('views/pages/CoinPage')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <DashboardDefault />,
        },
        {
            path: 'dashboard',
            children: [
                {
                    path: 'default',
                    element: <DashboardDefault />,
                },
            ],
        },
        {
            path: 'utils',
            children: [
                {
                    path: 'util-typography',
                    element: <UtilsTypography />,
                },
            ],
        },
        {
            path: 'utils',
            children: [
                {
                    path: 'util-color',
                    element: <UtilsColor />,
                },
            ],
        },
        {
            path: 'utils',
            children: [
                {
                    path: 'util-shadow',
                    element: <UtilsShadow />,
                },
            ],
        },
        {
            path: 'icons',
            children: [
                {
                    path: 'tabler-icons',
                    element: <UtilsTablerIcons />,
                },
            ],
        },
        {
            path: 'icons',
            children: [
                {
                    path: 'material-icons',
                    element: <UtilsMaterialIcons />,
                },
            ],
        },
        {
            path: 'sample-page',
            element: <SamplePage />,
        },
        {
            path: 'news-page',
            element: <NewsPage />,
        },
        {
            path: `all-cryptocurrencies/`,
            element: <AllCryptosPage />,
        },
        {
            path: `all-cryptocurrencies/:id`,
            element: <CoinPage />,
        },
    ],
};

export default MainRoutes;
